import { Alert, Backdrop, Box, Button, CircularProgress, Container, CssBaseline, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, Paper, Snackbar, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import Creditos from "../registroCreditos/Creditos";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { axiosClient } from "../AxiosClient";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px !important',
    gap: '10px !important',
    backgroundColor: '#161e55 !important',
    color: '#ffff !important',
    margin: '0px 1rem !important',
    '&:hover': {
        backgroundColor: '#A8C8AF !important',
    },
})

const titles = ["Credito Id", "Valor", "Número cuotas", "Documento cliente", "Nombre cliente", ""];

const creditos = [
    {
        "creditId": 1,
        "valor": 100000,
        "quotas": 10,
        "documentNumberClient": 12345678,
        "nameClient": "Jonhs Duals"
    }
]

export default function EliminarCredit() {
    const [searcher, setSearcher] = useState("");
    const [open, setOpen] = useState(false);
    const [creditEliminar, setCreditEliminar] = useState();
    const [credits, setCredits] = useState();
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState();
    const [texts, setTexts] = useState("");

    const handleChangeClient = (event) => {
        setSearcher(event.target.value);
    }

    const handleVerification = (credit) => {
        setCreditEliminar(credit);
        setOpen(!open);
    }

    const handleClose = () => {
        setOpen(!open);
    }

    const handleCloseSnackbar = () => {
        setOpenSnackbar(!openSnackbar);
    }

    const handleSearch = () => {
        setOpenBackdrop(true);
        axiosClient.get(`/v1/credits/credits-approved/${searcher}`)
        .then(response => {
            if(response.status === 200) {
                setCredits(response.data);
            } else {
                console.log("Error fetch")
                setSeverity("error");
                setTexts("ocurrió un error al consultar los créditos, por favor intenta en unos segundos");
                setOpenSnackbar(true);
            }
        })
        .catch(error => {
            console.log("Error fetch " + error.message)
            setSeverity("error");
            setTexts("ocurrió un error al consultar los créditos, por favor intenta en unos segundos");
            setOpenSnackbar(true);
        });
        setOpenBackdrop(false);
    }

    const handleDelete = () => {
        setOpenBackdrop(true);
        setOpen(false);
        axiosClient.patch(`/v1/credits/anular-credito/${creditEliminar.creditId}`)
        .then(response => {
            if(response.status === 200) {
                setSeverity("success");
                setTexts("Se eliminó correctamente el crédito");
                setOpenSnackbar(true);
                handleSearch();
            } else {
                setSeverity("error");
                setTexts("Ocurrió un error en la eliminación del crédito, por favor intenta de nuevo en unos segundos");
                setOpenSnackbar(true);
                setOpenBackdrop(false);
            }
        })
        .catch(error => {
            setSeverity("error");
            setTexts("Ocurrió un error en la eliminación del crédito, por favor intenta de nuevo en unos segundos");
            setOpenSnackbar(true);
            setOpenBackdrop(false);
        });
    }

    return (
        <React.Fragment>
            <Box sx={{width: '100%', marginTop: '1.9rem', marginBottom: '1rem'}}>
                <Container>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container marginTop={2} alignItems={'center'}>
                        <h1>Eliminar Créditos</h1>
                        <Grid sx={{width: '100%'}}>
                            <Grid sx={{display: 'flex', alignItems: 'center'}}>
                                <Box mt={5} sx={{width: '70%'}}>
                                    <FormControl fullWidth>
                                        <TextField id="id" label="Documento cliente ó id crédito" value={searcher} onChange={handleChangeClient} ></TextField>
                                    </FormControl>
                                </Box>
                                <Box mt={5}>
                                    <ButtonAdd onClick={handleSearch}>Buscar</ButtonAdd>
                                </Box>
                            </Grid>
                            <Grid mt={5}>
                            {credits && 
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            {titles.map(title => 
                                                (<TableCell key={title} align="center">{title}</TableCell>)
                                            )}
                                        </TableHead>
                                        <TableBody>
                                            { credits?.length > 0 ?
                                                credits.map(credit => (
                                                    <TableRow key={credit.creditId} sx={{'&:last-child td, &:last-child th': { border: 0 }}}>
                                                        <TableCell align="center">{credit.creditId}</TableCell>
                                                        <TableCell align="center">{credit.value}</TableCell>
                                                        <TableCell align="center">{credit.quotasNumber}</TableCell>
                                                        <TableCell align="center">{credit.documentNumberClient}</TableCell>
                                                        <TableCell align="center">{credit.nameClient}</TableCell>
                                                        <TableCell align="center"><ButtonAdd onClick={() => handleVerification(credit)}><DeleteIcon></DeleteIcon></ButtonAdd></TableCell>
                                                    </TableRow>
                                                    ))
                                                :
                                                <TableRow  sx={{'&:last-child td, &:last-child th': { border: 0 }, textAlign: 'center'}}>{"No hay coincidencias"}</TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdrop}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleCloseSnackbar}>
                <Alert sx={{width: '100%'}} severity={severity}>{texts}</Alert>
            </Snackbar>
            <Dialog onClose={handleClose} open={open} aria-describedby="alert-dialog-slide-description">
                <DialogTitle>
                    Eliminación Crédito
                </DialogTitle>
                <DialogContent id="alert-dialog-slide-description">
                    <DialogContentText>
                        {`¿Está seguro de eliminar el crédito número ${creditEliminar?.creditId} del cliente ${creditEliminar?.nameClient}?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonAdd onClick={handleDelete}>Eliminar</ButtonAdd>
                    <ButtonAdd onClick={handleClose}>Cancelar</ButtonAdd>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}